import React from "react";
import "./CountryCard.css";
import Image from "../Image/Image";
import Text from "../Text/Text";

const FORMATS = ["card--small", "card--medium", "card--large"];

const CountryCard = ({ onClick, image, format, description }) => {
  const checkCardFormat = FORMATS.includes(format) ? format : FORMATS[1];
  return (
    <section className={`card ${checkCardFormat}`} onClick={onClick}>
      <Image src={image} className="image" />
      <Text content={description} style={{ "font-color": "white" }} />
    </section>
  );
};

export default CountryCard;
